<template>
    <v-layout v-if="$can('manage', 'job')">
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Job
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="dialog=true" :disabled="!$can('update', 'Points')"><v-icon class="mr-2" small>fa-plus</v-icon> Reset all Result and Rerun </v-btn>
                    <v-dialog v-model="dialog" max-width="300">
                        <v-card>
                            <v-card-title class="primary white--text title">
                                Reset all result
                            </v-card-title>
                            <v-card-text>
                                Reset all result will delete all result and rerun with latest setting.
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" @click="addJob('data reset')">OK</v-btn>
                                <v-btn @click="dialog=false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-btn class="accent ml-2" @click="secondDialog=true" :disabled="!$can('update', 'Model')"><v-icon class="mr-2" small>fa-plus</v-icon> Train Comp Power Model </v-btn>
                    <v-dialog v-model="secondDialog" max-width="300">
                        <v-card>
                            <v-card-title class="primary white--text title">
                                Train Comp Power Model
                            </v-card-title>
                            <v-card-text>
                                This will retrain the Comp Power Model
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" @click="addJob('train comp power model')">OK</v-btn>
                                <v-btn @click="secondDialog=false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="points"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.job_id }}</td>
        <td class="text-xs-left">{{ props.item.job_type }}</td>
        <td class="text-xs-left">
            {{props.item.job_status}}
        </td>
        <td class="text-xs-left">{{ props.item.meta }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'Points') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'Points') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">No Result Yet</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getJob, deleteJob, putJob} from '../helper'

export default {
    name: 'Job',

  data: () => ({
      dialog: false,
      secondDialog: false,
      headers: [
        {
          text: 'Job ID',
          align: 'left',
          sortable: true,
          value: 'job_id'
        },
        { text: 'Type', value: 'job_type' },
        { text: 'Status', value: 'job_status' },
        { text: 'Meta', value: 'meta', sortable: false },
      ],
      points: [
      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
    watch: {
      dialog ( newdialog ) {
        this.refresh()
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {

      },

      async deleteItem (item) {
        const index = this.points.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.points.splice(index, 1)
          await deleteJob({
            'job_id': item.job_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async addJob(type) {
        await putJob({
          'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
          'job_type': type,
          'job_status': 'pending',
          'meta': null
        })
          this.dialog=false;
          this.secondDialog=false;
        this.refresh()
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.points[this.editedIndex], this.editedItem)
        } else {
          this.points.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getJob({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.points = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
